import { render, staticRenderFns } from "./HorizontalBarAnswerItem.vue?vue&type=template&id=58dbfb28&"
import script from "./HorizontalBarAnswerItem.vue?vue&type=script&lang=js&"
export * from "./HorizontalBarAnswerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports